import React from "react";
import Header from "../common/header/Header";
import Hero from "../components/hero/Hero";
import About from "../components/about/About";
import Projects from "../components/project/Projects";
import Service from "../components/services/Service";
import AllFeatures from "../components/features/AllFeatures";
import Footer from "../common/footer/Footer";

const HomeDefault = () => {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Service />
      <Projects />
      <AllFeatures />
      <Footer />
    </>
  );
};

export default HomeDefault;
